var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"popupThanks\" style=\"max-width:583px;\" class=\"popup thanks\"><img src=\"{{success_svg}}\" width=\"223\" alt=\"\"><h2>Success!</h2><p>Application link has been sent to<br>{{email_content.email}}</p><a ng-click=\"$dismiss()\" style=\"text-decoration:none;\" class=\"backto\">Back to Dashboard</a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/sendApplicationLink/sendApplicationLinkModal/sendApplicationLinkSuccessModal.jade
// module id = 532
// module chunks = 0